import { SVGProps, cloneElement, isValidElement } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const BaseSVGIcon = ({ children, ...props }: Props) => {
  if (isValidElement(children)) {
    return cloneElement(children, { width: 20, height: 20, ...props });
  }

  return null;
};

export default BaseSVGIcon;
